// extracted by mini-css-extract-plugin
module.exports = {"remove_button":"Footer_remove_button__3JqCL"};